export enum WebRpmTrackerSearchParamKey {
  END_DATE = 'endDate',
  SECTION = 'section',
}
